<template>
  <div id="returnGoodsInfo">
    <el-row class="clearfix" style="margin-bottom: 15px;">
      <el-col class="fl" :span="2">
        <el-button size="small" @click="backGo()">返回</el-button>
      </el-col>
      <el-col class="fr" :span="1">
        <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
      </el-col>
    </el-row>
    <el-col class="fl searthPart" style="width: 20%;">
      <p class="headerT">采购退货信息</p>
      <el-form ref="returnForm" :model="returnForm" label-width="100px" :label-position="labelPosition">
        <el-form-item label="采购退货单号:">
          <el-input style="width: 85%;" :disabled="true" v-model="returnForm.code">
          </el-input>
          <i class="iconfont hohofast-copy copyBtn" @click="handleCopy(returnForm.code,$event)"></i>
        </el-form-item>
        <el-form-item label="采购订单编号:">
          <el-input  style="width: 85%;" :disabled="true" v-model="returnForm.pCode"></el-input>
          <i class="iconfont hohofast-copy copyBtn" @click="handleCopy(returnForm.pCode,$event)"></i>
        </el-form-item>
        <el-form-item label="出入库编号:">
          <el-input  style="width: 85%;" :disabled="true" v-model="returnForm.storageCode"></el-input>
          <i class="iconfont hohofast-copy copyBtn" @click="handleCopy(returnForm.storageCode,$event)"></i>
         </el-form-item>
        <el-form-item label="供应商:">
          <el-input :disabled="true" v-model="returnForm.supplierName"></el-input>
        </el-form-item>
        <el-form-item label="退货时间:">
          <el-input :disabled="true" v-model="returnForm.createTime"></el-input>
         </el-form-item>
        <el-form-item label="退货原因:">
          <el-input :disabled="true" v-model="returnForm.reason"></el-input>
        </el-form-item>
      </el-form>
    </el-col>
    <el-col class="fr" style="width: 78%;">
      <!-- <p class="headerT">供应商信息详情</p> -->
      <el-card class="box-card fr" style="width: 100%;">
        <el-table
          :data="returnData"
          border
          :header-cell-style="{'text-align':'center'}"
          style="width: 100%"
          @row-click="goToDetail()">
          <el-table-column
            align="center"
            type="index"
            label="序号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="materialCoding"
            label="物料编号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="materialName"
            label="物料名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="number"
            label="退货数量">
          </el-table-column>
          <el-table-column
            align="center"
            prop="price"
            label="采购单价(元）">
          </el-table-column>
          <el-table-column
            align="center"
            prop="amout"
            label="合计金额">
          </el-table-column>
        </el-table>
      </el-card>
    </el-col>
    
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import clip from '@/util/clipboard'

  import {
    purchasingReturnDetails
  } from "../../api/api";

  export default {
    name: 'returnGoodsInfo',
    components: {
    },
    data () {
      return {
        orderParams:{},
        labelPosition:'left',
        returnForm:{},
        orderId:'',
        returnData: []
      }
    },
    mounted(){
        
    },
    created:function(){
        this.$destroy(); //销毁生命周期
        if (!this.$route.query.orderId) {
            let userOrderId = sessionStorage.getItem('saveOrderId');
            this.orderId = userOrderId;
        }else{
            let orderId = this.$route.query.orderId
            this.orderId = orderId
        }
        this.getPurchasingReturnDetails()    
    },
    methods: {
      //复制内容
        handleCopy(text, event) {
            clip(text, event)
            console.log('clicp')
        },
       //获取采购退货列表
        getPurchasingReturnDetails(){
            let para={
                id:this.orderId
            };
            purchasingReturnDetails(para).then(res => {   
                if (res.data.status==100) {       
                    this.returnData = res.data.results.detailsInfo.list
                    this.returnForm = res.data.results.info
                    this.returnForm.createTime = this.filters.formatDate(this.returnForm.createTime)
                    sessionStorage.setItem('saveOrderId',res.data.results.info.id); //缓存订单ID
                }else{
                    this.$message({
                        message: res.data.message,
                        type: "error"
                    });
                }
            }).catch((error) =>{
                this.$Message.error(error.message);
            })
        },
      //返回上一页
        backGo() {
            this.$router.go(-1)
        },
        refresh() {
            this.getPurchasingReturnDetails()
        }
    }
  }
</script>

<style type="text/css" lang="scss" scoped>
  #returnGoodsInfo{
    font-size: 14px;
    .copyBtn{font-size: 24px;cursor: pointer;display:block;float: right;}
    .el-input{width: 85%;}
    .headerT{font-size: 16px;margin:0 0 15px 0;}
  }
</style>



// WEBPACK FOOTER //
// returnGoodsInfo.vue?3f9db0c2